import { onUnmounted } from "vue";
import { CollectionEntity, SubsetEntity } from "../firebase";
import { DocumentEntity } from "../firebase/document-entity";
import { vueFirestoreSubsetRef, vueFirestoreDocRef } from "./vue-firestore-refs";
/*
 *   Copyright (c) 2021 Busy Human LLC
 *   All rights reserved.
 *   This file, its contents, concepts, methods, behavior, and operation  (collectively the "Software") are protected by trade secret, patent,  and copyright laws. The use of the Software is governed by a license  agreement. Disclosure of the Software to third parties, in any form,  in whole or in part, is expressly prohibited except as authorized by the license agreement.
 */
export var EntityPlaceholder;
(function (EntityPlaceholder) {
    EntityPlaceholder["Document"] = "document";
    EntityPlaceholder["Subset"] = "subset";
})(EntityPlaceholder || (EntityPlaceholder = {}));
/*
 *   Copyright (c) 2021 Busy Human LLC
 *   All rights reserved.
 *   This file, its contents, concepts, methods, behavior, and operation  (collectively the "Software") are protected by trade secret, patent,  and copyright laws. The use of the Software is governed by a license  agreement. Disclosure of the Software to third parties, in any form,  in whole or in part, is expressly prohibited except as authorized by the license agreement.
 */
export var VueFirestoreComposerModule;
(function (VueFirestoreComposerModule) {
    /**
     * Saves & manages the firestore context for a particular Vue component
     */
    class VueFirestoreContext {
        constructor(options) {
            this.entities = {};
            var keys = Object.keys(options);
            keys.forEach(key => {
                this.entities[key] = options[key];
            });
        }
        forEachEntity(fn) {
            var keys = Object.keys(this.entities);
            keys.forEach(key => {
                var node = this.entities[key];
                fn(node, key);
            });
        }
        entityByKey(key) {
            return this.entities[key];
        }
        refs() {
            var map = {};
            this.forEachEntity((entity, key) => {
                if (entity instanceof DocumentEntity) {
                    map[key] = vueFirestoreDocRef(entity);
                }
                else if (entity instanceof SubsetEntity) {
                    map[key] = vueFirestoreSubsetRef(entity);
                }
                else if (entity instanceof CollectionEntity) {
                    console.log(entity);
                    throw new Error(`VueFirestoreComposer only accepts a DocumentEntity or a SubsetEntity, not a CollectionEntity`);
                }
                else {
                    throw new Error(`Unrecognized ref type in VueFirestoreContext: ${typeof entity}`);
                }
            });
            return map;
        }
        mapEntities() {
            // var map: any = {};
            // this.forEachEntity((entity, key) => {
            //     map[key] = entity;
            // });
            // return map;
            return this.entities;
        }
        cleanup() {
            // TODO: Now that we're recycling documents, we need to be more surgical about our cleanup
            // For example, we may be listening for changes on a document globally independent of this vue component
            // But this cleanup woudl eliminate that
            this.forEachEntity((entity, key) => {
                entity.cleanup();
            });
        }
    }
    VueFirestoreComposerModule.VueFirestoreContext = VueFirestoreContext;
    function vueFirestoreComposer(options) {
        const context = new VueFirestoreContext(options);
        onUnmounted(() => {
            context.cleanup();
        });
        return {
            ...context.refs(),
            fire: context.mapEntities()
        };
    }
    VueFirestoreComposerModule.vueFirestoreComposer = vueFirestoreComposer;
})(VueFirestoreComposerModule || (VueFirestoreComposerModule = {}));
//# sourceMappingURL=vue-firestore-composer.js.map